import $ from 'jquery';

$(function () {
  $('.option-container input[type="radio"], .checkbox-custom').each(function (
    idx,
    input,
  ) {
    if ($(input).parent().hasClass('field_with_errors')) {
      $(input).unwrap();
    }
  });

  $('.option-container').on('change', 'input[type="radio"]', function () {
    const checked = $(this).val();
    const checkedName = $(this).labels().html();
    const $optionContainer = $(this).closest('.option-container');
    const optionName = $optionContainer.attr('name');

    if ($optionContainer.attr('previous-value')) {
      $('.js-change-confirm .js-option').html(checkedName);
      $('.js-change-confirm').modal({ backdrop: 'static' });
    } else {
      $optionContainer.attr('previous-value', checked);
    }
    $optionContainer.addClass('active');
  });

  $('.js-change-confirm button.cancel').on('click', function () {
    const $optionContainer = $('.option-container.active');
    const optionName = $optionContainer.data('name');
    const previousValue = $optionContainer.attr('previous-value');
    $('#solicitation_' + optionName + '_' + previousValue).prop(
      'checked',
      true,
    );

    $optionContainer.removeClass('active');
  });

  $('.js-change-confirm button.confirm').on('click', function () {
    const $optionContainer = $('.option-container.active');
    const optionName = $optionContainer.data('name');
    const newSelection = $('input:checked', $optionContainer).val();
    $optionContainer.attr('previous-value', newSelection);

    $optionContainer.removeClass('active');
  });

  //add the required attributes for the checkboxes we have
  const requiredCheckboxes = $(':checkbox[required]');
  //on create/edit mode
  requiredCheckboxes.on('change', function () {
    if (requiredCheckboxes.is(':checked')) {
      requiredCheckboxes.prop('required', false);
    } else {
      requiredCheckboxes.prop('required', true);
    }
  });
  //on load
  requiredCheckboxes.trigger('change');

  $('.option-container').each(function () {
    $(this).attr('previous-value', $('input:checked', this).val());
  });

  //trigger tooltip on
  $('[data-toggle="tooltip"]').tooltip();
});
